import {
  Chip,
  ChipCheckmark,
  ChipSet,
} from '@material/react-chips';
import './Chips.scss';

/**
 * Chips MCWR Component
 *
 * @version ./package.json
 */
export default {
  Chip, ChipCheckmark, ChipSet
};

export {
  Chip, ChipCheckmark, ChipSet
};
